import OIValidation from './oi/validation';
import OIForm from './oi/form.js';

import OCPValidation from './ocp/validation';
import OCPForm from './ocp/form.js';

import config from '../'

const ratingProducts = {
    oi: {
        type: 'oi',
        name: "Owner's Interest",
        description:
            "Owners of construction projects should have their own liability coverage. The Owner's Interest policy closes the gaps in the owner's liability insurance program and assure more adequate protection.",
        ratingEngine: `${config.ratingsUrl}/api/calcrating/oi`,
        formJSON: OIForm,
        Validation: OIValidation,
        checkClearance: true,
        subtitle: 'with optional Excess Coverage',
        features: [
            'Owners Interest is a commercial general liability policy for an owner hiring a general contractor to construct a new building or renovate an existing building for a residential or commercial project.'
        ],
        applicationForm: {
            download: 'Application Form',
            alt: 'Application Form',
            fileName: 'OI Application Form Fillable'
        }
    },

    ocp: {
        type: 'ocp',
        name: 'Owners and Contractors Protective',
        description:
            "The Owners and Contractors Protective policy responds to liability arising out of the insured's own acts or omissions in connection with its general supervision of the contractor's operations.",
        ratingEngine: `${config.ratingsUrl}/api/calcrating/oi`,
        formJSON: OCPForm,
        Validation: OCPValidation,
        checkClearance: true,
        subtitle: '',
        features: [
            'OCP provides coverage to supplement the owner’s additional insured status on the general contractor’s policy during construction – supported or unsupported.'
        ],
        applicationForm: {
            download: 'Application Form',
            alt: 'Application Form',
            fileName: 'OCP Application Form Fillable'
        }
    }
};

exports.getRatingProduct = type => ratingProducts[type] || ratingProducts['oi'];

export default ratingProducts;
